module.exports = __webpack_public_path__ + "static/media/QR-code-with-icon.ababcf4f.png";